import { Device } from '../../server-types';
import { Options } from '../../components/forms/fields/types';

export const mapDevicesToFormProps = (
    devices: Array<Device>
): Array<Options> => devices.map(({ id, customName, name }) => ({
    id,
    name: customName || name,
}));
